module.exports = __webpack_public_path__ + "img/Xionglei_Beijing.267605ab.png";